module.exports = __webpack_public_path__ + "img/dinners-club.310aa57d.svg";